import useSWRInfinite from 'swr/infinite'
import { useRecoilValue } from 'recoil'

import {
  getEngagementMessageList,
  getEngagementMessageListKey,
} from '@/apis/letter'
import { UnreadMessageStatus, EngagementMessageListReq } from '@/types/letter'
import { userState } from 'Store/user'

export function useEngagementList(
  tab: 'System' | 'Personal' | 'Engagement',
  readStatus?: UnreadMessageStatus
) {
  const user = useRecoilValue(userState)
  const platform = 'web'

  const { data, error, isValidating, size, setSize, isLoading, mutate } =
    useSWRInfinite(
      tab === 'Engagement'
        ? (index) =>
            getEngagementMessageListKey({
              platform,
              size: 20,
            })(index)
        : () => undefined,
      ({ req }: { req: EngagementMessageListReq }) =>
        getEngagementMessageList(req),
      {
        revalidateOnFocus: false,
        dedupingInterval: 60000, // 1分钟内去重
      }
    )
  const hasLoaded = !user || data !== undefined || error !== undefined

  const loadMore = () => {
    if (isValidating || error) return
    if (size >= 5) return
    if (data && data.length >= size) {
      const lastPage = data[size - 1]
      if (lastPage?.list && lastPage.list.length >= 20) {
        setSize((size) => size + 1)
      }
    }
  }

  // 获取未读数量
  const getUnreadCount = () => {
    return readStatus?.unread_engagement_messages ? 1 : 0
  }

  return {
    data:
      data
        ?.map((page) => page?.list || [])
        .flat()
        .filter((item) => item && item.message_id) || [],
    hasLoaded,
    error,
    isValidating,
    isLoading,
    mutate,
    loadMore,
    getUnreadCount,
  }
}
